/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/briefcase.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.Cube_1.geometry} material={materials.Base} />
      <mesh geometry={nodes.Cube_2.geometry} material={materials.Handle} />
      <mesh geometry={nodes.Cube_3.geometry} material={materials.Trim} />
    </group>
  )
}

useGLTF.preload('/briefcase.glb')
